import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import OrderVideoView from '../components/OrderVideoView';
import OrdersLoadingView from '../components/OrdersLoadingView';
import NoAccess from '../components/NoAccess';
import { Order } from '../models/order';

type PathParams = {
  orderId: string;
  stationId?: string;
  videoTime?: string;
};

const GET_ORDER_QUERY = gql`
  query GetOrder($orderId: ID!) {
    order(id: $orderId) {
      id
      platformId
      price
      score
      stationVideos {
        stationId
        state
        stationName
        videoUrl
        recognitionData {
          startTime
          keyframesTime
          endTime
          dateProcessed
          correctOrder
        }
      }
      customer {
        name
      }
      location {
        id
        name
        timezoneOffset
      }
      brand {
        id
        name
      }
      items {
        name
        quantity
        modifiers {
          name
          choice
          quantity
        }
        notes
      }
      notes
      phaseStatuses {
        phase {
          name
        }
        started
        ended
      }
    }
  }
`;

export default function OrderView() {
  const { orderId, stationId = null, videoTime = null } =
    useParams<PathParams>();

  const orderQuery = useQuery(GET_ORDER_QUERY, {
    variables: { orderId },
  });

  if (orderQuery.loading) {
    return <OrdersLoadingView />;
  }

  if (orderQuery.error) {
    if (
      orderQuery.error.message ===
      "Cannot destructure property 'brandIds' of '(intermediate value)' as it is undefined."
    ) {
      return <NoAccess />;
    }
    return <div>{orderQuery.error.message}</div>;
  }

  const order: Order | null = orderQuery.data?.order || null;

  return (
    <OrderVideoView
      order={order}
      selectedStationId={stationId}
      videoTime={videoTime}
    />
  );
}

